/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'system';
const componentName = 'system-settings-syslog-config';
const prefix = `${moduleName}.${componentName}`;

export const syslogServerLabel = `${prefix}.syslogServerLabel`;
export const syncTheSyslogServersToSeLabel = `${prefix}.syncTheSyslogServersToSeLabel`;
export const syslogServerPlaceholder = `${prefix}.syslogServerPlaceholder`;
export const syslogServerHelperText = `${prefix}.syslogServerHelperText`;

export const ENGLISH = {
    [syslogServerLabel]: 'Syslog Server(s)',
    [syncTheSyslogServersToSeLabel]: 'Sync the Syslog Server(s) to SEs',
    [syslogServerPlaceholder]: 'Enter Syslog Servers',
    [syslogServerHelperText]: 'Accepts IPv4 addresses, IPv6 addresses, and hostnames',
};
